// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tier_popup_view {
  position: relative;
}
.tier_popup_view .close-btn {
  width: 5%;
  position: absolute;
  border: none;
  background: none;
  height: 20px;
  top: 22px;
  right: 0;
}
.tier_popup_view .close-btn:after {
  content: "";
  background: url(https://cdn.upmchp.com/providerdirectory/assets/images/close_image.svg);
  background-size: contain;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  top: 0;
}
.tier_popup_view .mat-mdc-dialog-title {
  border-bottom: 1px solid var(--grey-20);
  color: var(--brand-60);
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  font-size: 1.25rem;
  font-weight: bold;
}
.tier_popup_view .mat-mdc-dialog-content .alternate-medication-table {
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 10fr;
  grid-template-rows: auto;
  grid-gap: 0;
  font-size: 1rem;
  color: var(--neutral-60);
}
.tier_popup_view .mat-mdc-dialog-content .alternate-medication-table.alternate-medication-table-rows {
  padding: 1rem 0.5rem;
  border-bottom: 1px solid var(--grey-30);
}
.tier_popup_view .mat-mdc-dialog-content .alternate-medication-table.alternate-medication-table-rows:last-child {
  border-bottom-width: 0;
}
.tier_popup_view .mat-mdc-dialog-content .alternate-medication-table > div {
  padding: 0.5rem;
}
.tier_popup_view .mat-mdc-dialog-content .alternate-medication-table > div.alternate-medication-table__header {
  font-weight: 700;
  font-size: 1rem;
  border-bottom: 1px solid var(--grey-30);
  border-right: 0;
  border-left: 0;
  padding: 1rem;
  background-repeat: no-repeat;
}
.tier_popup_view .mat-mdc-dialog-actions {
  border-top: 1px solid var(--grey-20);
  padding: 1.875rem 0.625rem;
  display: inherit;
  display: flex;
  justify-content: end;
}
.tier_popup_view .mat-mdc-dialog-actions .btn {
  font-size: 1rem;
  line-height: 2.5em;
  width: 9.938em;
  border-radius: 0.188em;
  margin-right: 1.625em;
  border-width: 0;
}
.tier_popup_view .mat-mdc-dialog-actions .btn.cancel_btn {
  background-color: var(--white);
  color: var(--grey-70);
  width: 6.563em;
  border: solid 1px var(--grey-50);
  width: 7.563rem;
  height: 2.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.57;
}

ods-button::part(button) {
  border: solid 1px var(--neutral-40) !important;
  background-color: var(--white);
  color: var(--grey-70);
}
ods-button::part(button):hover {
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/medication/components/tier-modal/tier-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AACN;AACM;EACI,WAAA;EACA,uFAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AACV;AAGI;EACI,uCAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;AADR;AAKM;EACE,WAAA;EACA,aAAA;EACA,+BAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;AAHR;AAIQ;EACI,oBAAA;EACA,uCAAA;AAFZ;AAGY;EACI,sBAAA;AADhB;AAIQ;EACI,eAAA;AAFZ;AAGY;EACI,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,4BAAA;AADhB;AAOM;EACE,oCAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;AALR;AAMQ;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AAJV;AAKU;EACE,8BAAA;EACA,qBAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAHZ;;AAQA;EACE,8CAAA;EACA,8BAAA;EACA,qBAAA;AALF;AAME;EACE,gBAAA;AAJJ","sourcesContent":[".tier_popup_view {\n    position: relative;\n  \n    .close-btn {\n      width:5%;\n      position:absolute;\n      border: none;\n      background: none;\n      height: 20px;\n      top:22px;\n      right:0;\n  \n      &:after {\n          content:'';\n          background:url(https://cdn.upmchp.com/providerdirectory/assets/images/close_image.svg);\n          background-size: contain;\n          width:20px;\n          height:20px;\n          position:absolute;\n          left: 0;\n          top: 0;\n      }\n    }\n\n    .mat-mdc-dialog-title {\n        border-bottom: 1px solid var(--grey-20);\n        color: var(--brand-60);\n        margin-bottom: 1rem;\n        padding-bottom: 1.000rem;\n        font-size: 1.25rem;\n        font-weight: bold;\n      }\n\n      .mat-mdc-dialog-content {\n      .alternate-medication-table {\n        width: 100%;\n        display: grid;\n        grid-template-columns: 3fr 10fr;\n        grid-template-rows: auto;\n        grid-gap: 0;\n        font-size: 1rem;\n        color: var(--neutral-60);\n        &.alternate-medication-table-rows {\n            padding: 1rem 0.5rem;\n            border-bottom: 1px solid var(--grey-30);\n            &:last-child {\n                border-bottom-width: 0;\n            }\n        }\n        >div {\n            padding: 0.5rem;\n            &.alternate-medication-table__header {\n                font-weight: 700;\n                font-size: 1rem;\n                border-bottom: 1px solid var(--grey-30);\n                border-right: 0;\n                border-left: 0;\n                padding: 1rem;\n                background-repeat: no-repeat;\n            }\n        }\n    }\n}\n\n      .mat-mdc-dialog-actions {\n        border-top: 1px solid var(--grey-20);\n        padding: 1.875rem 0.625rem;\n        display: inherit;\n        display: flex;\n        justify-content: end;\n        .btn {\n          font-size: 1rem;\n          line-height: 2.5em;\n          width: 9.938em;\n          border-radius: 0.188em;\n          margin-right: 1.625em;\n          border-width: 0;\n          &.cancel_btn {\n            background-color: var(--white);\n            color: var(--grey-70);\n            width: 6.563em;\n            border: solid 1px var(--grey-50);\n            width: 7.563rem;\n            height: 2.5rem;\n            font-size: 0.875rem;\n            font-weight: 500;\n            line-height: 1.57;\n          }\n        }\n      }\n}\nods-button::part(button) {\n  border: solid 1px var(--neutral-40) !important;\n  background-color: var(--white);\n  color: var(--grey-70);\n  &:hover {\n    background: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
